import DodoneEditModal from 'app/dodones/edit/Modal'

export default ({ dodone }) => {
  return (
    <DodoneEditModal attributesNames="comment">
      <div className="darkest-gray-transparent-box rounded px-d py-2">
        {dodone.comment ? (
          <pre>{dodone.comment}</pre>
        ) : (
          <div className="italic">Empty Comment</div>
        )}
      </div>
    </DodoneEditModal>
  )
}
